export enum TableHeaderType {
	Icon,
	ID,
	Description,
	Other
}
